import { Fragment, useCallback, useContext, useRef, useState } from "react";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import { menuRoutes } from "../../../router/menu";
import PageHeader from "../../../layout/shared/page-header";
import { PrivilegeContext } from "../../../components/priviledge/PriviledgeProvider";
import { Button } from "rizzui";
import cn from "../../../utils/classNames";
import GeneralExpenseList from "./GeneralExpenseList";
import GeneralExpenseImportModal from "../components/GeneralExpenseImportModal";

const GeneralExpenseListWrapper = () => {

    const [isOpenFormDrawer, setIsOpenFormDrawer] = useState(false);
    const [expenseSelected, setExpenseSelected] = useState<any | null>(null);
    const [isOpenImportModal, setIsOpenImportModal] = useState(false);
    const generalExpenseTableRefetchRef = useRef<(() => void) | null>(null);

    const breadCrumb = [
        { name: 'Administración' },
        { name: 'Gastos Generales' },
        { name: 'Listado', href: menuRoutes.generalExpenses.path },  
    ];

    const defaultFilters = {};

    const { userCan } = useContext(PrivilegeContext);
    const registerTableRefetch = useCallback((fn: () => void) => {
        generalExpenseTableRefetchRef.current = fn;
    }, []);

    return (
        <Fragment>
            <FiltersProvider>
                <PageHeader title="Listado de gastos generales" breadcrumb={breadCrumb}>
                    <div className="flex gap-3 mt-4 md:mt-0">
                    {
                        userCan('create', 'provider') &&
                        (
                            <Button
                                variant="outline"
                                onClick={() => setIsOpenImportModal(true)}
                            >
                                Importar Excel
                            </Button>
                        )
                    }
                    {
                        userCan('create', 'general_expense') &&
                        (
                            <Button
                                color="primary"
                                onClick={() => { 
                                    setIsOpenFormDrawer(true) 
                                    setExpenseSelected(null)
                                }}
                                className={cn(['mt-4 md:mt-0'])}
                            >
                                Crear Gasto
                            </Button>
                        )
                    }
                    </div>
                </PageHeader>
                <GeneralExpenseList 
                    openFormDrawer={isOpenFormDrawer} 
                    setOpenFormDrawer={setIsOpenFormDrawer} 
                    expenseSelected={expenseSelected} 
                    setExpenseSelected={setExpenseSelected} 
                    registerTableRefetch={registerTableRefetch}
                />
                <GeneralExpenseImportModal 
                    isOpen={isOpenImportModal} 
                    onClose={() => setIsOpenImportModal(false)} 
                    refetch={() => {
                        generalExpenseTableRefetchRef.current?.();
                    }} 
                />
            </FiltersProvider>
        </Fragment>
    );
};

export default GeneralExpenseListWrapper;
